<template>
    <div class="admin-main-header">
        <slot>
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ name: 'Forward', params: {target: 'Index'} }">首页</el-breadcrumb-item>
                <template v-for="(menu, index) in userAccessPathMenus">
                    <el-breadcrumb-item v-if="applyRoute(index)" :to="{ name: menu.menuViewName }" :key="menu.menuId">{{ menu.menuName }}</el-breadcrumb-item>
                    <el-breadcrumb-item v-else :key="menu.menuId">{{ menu.menuName }}</el-breadcrumb-item>
                </template>
            </el-breadcrumb>
        </slot>
    </div>
</template>

<script>
import { views } from '@/router.js';
import { findMenuByViewName, findMenuByMenuId } from '@/utils.js';

export default {
    name: 'AdminMainHeader',

    data() {
        return {
            userAccessPathMenus: []
        };
    },

    created() {
        let currentViewName = this.$route.name;
        let userNavMenuList = this.$store.state.loginUserAllData
            .userNavMenuList[0].subMenuList;
        if (Array.isArray(userNavMenuList)) {
            let userAccessMenu = findMenuByViewName(
                userNavMenuList,
                currentViewName
            );
            let userAccessPathMenus = [];
            this.collectUserAccessPathMenus(
                userNavMenuList,
                userAccessMenu,
                userAccessPathMenus
            );
            this.userAccessPathMenus = userAccessPathMenus.reverse();
        }
    },
    methods: {
        /**
         * 当前面包屑是否应用route
         */
        applyRoute(index) {
            let length = this.userAccessPathMenus.length;
            if (index != length - 1) {
                //不是最后一个?
                let viewName = this.userAccessPathMenus[index].menuViewName;
                if (views[viewName]) {
                    //存在对应的视图?
                    return true;
                }
            }
            return false;
        },
        collectUserAccessPathMenus(
            userNavMenuList,
            userAccessMenu,
            userAccessPathMenus
        ) {
            if (userAccessMenu) {
                userAccessPathMenus.push(userAccessMenu);
                userAccessMenu = findMenuByMenuId(
                    userNavMenuList,
                    userAccessMenu.parentMenuId
                );
                this.collectUserAccessPathMenus(
                    userNavMenuList,
                    userAccessMenu,
                    userAccessPathMenus
                );
            }
        }
    }
};
</script>

<style>
</style>